export default __webpack_public_path__ + "static/media/Tecnologia_potencia_tvs_ntorq_racing.75a7b4d8.jpg";